<template>
  <div class="row export-buttons-row">
    <div class="col-lg-offset-2 col-md-offset-2 col-lg-4 col-md-4 col-sm-6">
      <btn type="primary" v-on:click="onAddFilter" block>
        Add filter
      </btn>
    </div>
    <div class="col-lg-4 col-md-4 col-sm-6">
      <btn :disabled="disableGetData" v-on:click="onGetData" block>Get data</btn>
    </div>
  </div>
</template>
<script>
  export default {
    components: {},
    props: ['onGetData', 'onAddFilter', 'disableGetData'],
    name: 'filterTableFooter',
    data () {
      return {
        options: {}
      }
    }
  }
</script>
<style>
</style>
